export enum DateRangeEnum {
  All = 0,
  ThisMonth = 1,
  LastMonth = 2,
  LastThreeMonths = 3,
  LastSixMonths = 4,
  ThisYear = 5,
  LastYear = 6
} 